import * as React from 'react';
import Clipboard from 'react-clipboard.js';
import { Notification } from '@hotjar/webapp/components/Notification';
import { Portal } from '@hotjar/webapp/components/Portal';

interface CopyToClipboardProps {
  text: string;
  children: React.ReactNode;
  className?: string;
  onSuccess?: () => void;
  onClick?: () => void;
  title?: string;
}

interface CopyToClipboardState {
  show: boolean;
  timeoutId: number;
}

export class CopyToClipboard extends React.Component<CopyToClipboardProps, CopyToClipboardState> {
  constructor(props: CopyToClipboardProps) {
    super(props);
    this.state = { show: false, timeoutId: 0 };
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.getText = this.getText.bind(this);
  }

  handleSuccess(): void {
    let { timeoutId } = this.state;
    clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      this.setState({ show: false });
    }, 6000);
    this.setState({ show: true, timeoutId });

    const { onSuccess } = this.props;
    onSuccess?.();
  }

  handleClick(): void {
    const { onClick } = this.props;
    onClick?.();
  }

  getText(): string {
    const { text } = this.props;
    return text;
  }

  render(): React.ReactNode {
    const { children, className, title } = this.props;
    const { show } = this.state;
    return (
      <>
        <Clipboard
          className={className}
          component="span"
          option-text={this.getText}
          onSuccess={this.handleSuccess}
          onClick={this.handleClick}
          title={title}
        >
          {children}
        </Clipboard>
        <Portal>
          <Notification show={show}>Copied to clipboard</Notification>
        </Portal>
      </>
    );
  }
}
